<h2 style="display: flex; flex-direction: column; gap: 6px">
  <span>Trusted Devices</span>
  <span style="font-size: 14px; color: #b3afbb; font-family: 'Cera'">
    Trusted devices can login without requiring two-factor authentication via email.
  </span>
</h2>

<ng-container *ngIf="devicesState$ | async as devicesState">
  <ng-container *ngIf="!devicesState.error">
    <!-- happy path -->
    <div style="overflow-x: auto; max-width: 100%; padding-bottom: 16px">
      <mat-table *ngIf="devicesState.data.length > 0" [dataSource]="devicesState.data">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            {{ element.derived_name }}
          </mat-cell>
        </ng-container>

        <!-- This device Column -->
        <ng-container matColumnDef="this">
          <mat-header-cell mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <span *ngIf="element.nonce === deviceUuid" class="badge badge-grass">This device</span>
          </mat-cell>
        </ng-container>

        <!-- Country Column -->
        <ng-container matColumnDef="country">
          <mat-header-cell mat-header-cell *matHeaderCellDef>Country</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">{{ element.country }}</mat-cell>
        </ng-container>

        <!-- IP Address Column -->
        <ng-container matColumnDef="ip">
          <mat-header-cell mat-header-cell *matHeaderCellDef>IP address</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">{{ element.ip_address }}</mat-cell>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">{{ element.status | humanize }}</mat-cell>
        </ng-container>

        <!-- Trusted at Column -->
        <ng-container matColumnDef="trusted">
          <mat-header-cell mat-header-cell *matHeaderCellDef>Trusted at</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">{{ element.trusted_at | date: 'medium' }}</mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element" class="text-right justify-end">
            <sbnb-button [loading]="element.computed_revoking" size="mini" type="secondary" (clicked)="revoke(element)">
              Revoke
            </sbnb-button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <!-- loading -->
    <mat-spinner *ngIf="devicesState.loading" diameter="24"></mat-spinner>

    <!-- No items -->
    <sbnb-no-items
      *ngIf="!devicesState.loading && devicesState.data.length === 0"
      subtext="No trusted devices."
      size="mini"></sbnb-no-items>
  </ng-container>

  <!-- Error -->
  <ng-container *ngIf="devicesState.error">
    <span class="error">{{ devicesState.error }}</span>
    <sbnb-button style="display: block; margin-top: 12px" type="secondary" size="mini" (clicked)="fetchFromApi()">
      Retry
    </sbnb-button>
  </ng-container>
</ng-container>
